export default __webpack_public_path__ + "static/media/TL09.cdcf87f5.mp3";